import SingleMessageModalAbstract from './single-message-modal-abstract';

export default class ContactSingleMessageModalController extends SingleMessageModalAbstract {

    _getParametersForTemplatesStore() {
        return {
            ...super._getParametersForTemplatesStore(),
            onlyGlobal: true
        };
    }

    _getPreviewUrl(recipient) {
        return `templates/${this.selectedTemplateId}/preview/contact/${recipient.id}`;
    }

    _getSendRequestData() {
        return {
            ...super._getSendRequestData(),
            recipient_type: 'contact',
            contacts: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [this.recipientModel.id]
                    }
                ],
                count: 1
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/single-send/contact-single-message-modal.js